import { render, staticRenderFns } from "./_FacebookFrame.vue?vue&type=template&id=3d5ebc16&"
import script from "./_FacebookFrame.vue?vue&type=script&lang=js&"
export * from "./_FacebookFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports